import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, Row, Select, Divider, Tooltip, Icon } from 'antd';
import { inject, observer } from 'mobx-react';
// import {getStrategies} from "../../../Services";

const Option = Select.Option;

@inject('store')
@observer
class NewBotFormComponent extends Component {
    constructor(props) {
        super(props);
        this.state = { loading: true };
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.onSubmit(values);
            }
        });
    }

    render() {
        const { getFieldDecorator, getFieldValue, setFieldsValue } = this.props.form;

        if (!this.props.store.strategyStore.buySell.length === 0)
            return <div>You need to create a strategy first.</div>;

        const exchange = getFieldValue('exchange') || 'binance';

        const bases = this.props.store.exchangeConfig[exchange].supported_base;
        return (
            <Form>
                <Card bordered={false} style={{ marginBottom: 15 }}>
                    <Row gutter={24}>
                        <Col md={24}>
                            <Form.Item label="Name" required={true}>
                                {getFieldDecorator('name', {
                                    rules: [{ required: true, message: 'Field is required' }]
                                })(<Input size="large" />)}
                            </Form.Item>
                        </Col>

                        <Col md={24}>
                            <Form.Item label="Exchange">
                                {getFieldDecorator('exchange', {
                                    rules: [{ required: true, message: 'Field is required' }],
                                    initialValue: 'binance'
                                })(
                                    <Select
                                        size="large"
                                        onChange={() => setFieldsValue({ base_currency: '' })}
                                    >
                                        {Object.keys(this.props.store.exchangeConfig)
                                            .filter(e => this.props.store.exchangeConfig[e].enabled)
                                            .map(exchange => {
                                                return (
                                                    <Option key={exchange} value={exchange}>
                                                        {
                                                            this.props.store.exchangeConfig[
                                                                exchange
                                                            ].name
                                                        }
                                                    </Option>
                                                );
                                            })}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>

                        <Col md={24}>
                            <Form.Item label="Base Currency">
                                {getFieldDecorator('base_currency', {
                                    rules: [{ required: true, message: 'Field is required' }],
                                    initialValue: ''
                                })(
                                    <Select size="large">
                                        {bases.map(base => {
                                            return (
                                                <Option key={base} value={base}>
                                                    {base}
                                                </Option>
                                            );
                                        })}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>

                        <Col md={24}>
                            <Form.Item label="Strategy">
                                {getFieldDecorator('strategy_id', {
                                    rules: [{ required: true, message: 'Field is required' }]
                                })(
                                    <Select size="large">
                                        {this.props.store.strategyStore.buySell.map(s => {
                                            return (
                                                <Option value={s.id} key={s.id}>
                                                    {s.name}
                                                </Option>
                                            );
                                        })}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                        <Divider orientation="left">API Keys</Divider>
                        <Col md={12}>
                            <Form.Item label="Api Key" required={true}>
                                {getFieldDecorator('api_key', {
                                    rules: [{ required: true, message: 'Field is required' }]
                                })(
                                    <Input.Password
                                        size="large"
                                        style={{ textSecurity: 'disc', WebkitTextSecurity: 'disc' }}
                                    />
                                )}
                            </Form.Item>
                        </Col>

                        <Col md={12}>
                            <Form.Item label="Api Secret" required={true}>
                                {getFieldDecorator('api_secret', {
                                    rules: [{ required: true, message: 'Field is required' }]
                                })(<Input.Password size="large" />)}
                            </Form.Item>
                        </Col>

                        {exchange === 'kucoin' ? (
                            <Col md={24}>
                                <Form.Item
                                    label={
                                        <span>
                                            Api Passphrase{' '}
                                            <Tooltip
                                                placement="right"
                                                title={'This is not your trading password!'}
                                            >
                                                <Icon type="info-circle" theme="outlined" />
                                            </Tooltip>
                                        </span>
                                    }
                                >
                                    {getFieldDecorator('password', {
                                        rules: [{ required: true, message: 'Field is required' }]
                                    })(<Input.Password size="large" />)}
                                </Form.Item>
                            </Col>
                        ) : null}

                        <Button
                            size="large"
                            loading={this.props.busy}
                            onClick={this.handleSubmit.bind(this)}
                            style={{ width: '100%' }}
                            type="primary"
                        >
                            Create
                        </Button>
                    </Row>
                </Card>
            </Form>
        );
    }
}

export const ApexBotForm = Form.create({})(NewBotFormComponent);



// WEBPACK FOOTER //
// ./src/Account/Bots/New/ApexForm.js